module.exports = __webpack_public_path__ + "static/media/water_polo.263f8724.svg";